import { Paper, PaperProps, Stack, StackProps } from '@mantine/core';
import { PropsWithChildren } from 'react';
import styles from '@/app/pipelines/components/table/workflows/nodes/styles.module.css';

type WorkflowNodeProps = PropsWithChildren &
  PaperProps & {
    onClick?: () => void;
    stackProps?: StackProps & { 'data-testid'?: string };
    isSelected?: boolean;
  };
export const NodeCard = ({ children, onClick, stackProps, isSelected = false, ...props }: WorkflowNodeProps) => (
  <Paper
    shadow='md'
    w='max-content'
    className={`cursor-pointer ${isSelected ? styles.selectedWorkflow : ''}`}
    {...props}
    py='xs'
  >
    <Stack justify='center' align='center' gap='4' onClick={onClick} {...stackProps}>
      {children}
    </Stack>
  </Paper>
);
